import { defineMessages } from 'react-intl'

export default defineMessages({
  deadline: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.acceptConditions.deadline',
    defaultMessage: 'Response Deadline',
  },
  budget: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.acceptConditions.budget',
    defaultMessage: 'Budget',
  },
  media: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.acceptConditions.media',
    defaultMessage: 'Media',
  },
  buyOut: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.acceptConditions.buyOut',
    defaultMessage: 'Airing time',
  },
  territoryMarket: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.acceptConditions.territoryMarket',
    defaultMessage: 'TerritoryMarket',
  },
  fileFormat: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.acceptConditions.fileFormat',
    defaultMessage: 'Delivery in the right file format',
  },
  editingLevel: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.acceptConditions.editingLevel',
    defaultMessage: 'Editing level',
  },
  buyouts: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.acceptConditions.buyouts',
    defaultMessage: 'Usages',
  },
  fileUpload: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.acceptConditions.fileUpload',
    defaultMessage: 'File upload via the portal',
  },
  payment: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.acceptConditions.payment',
    defaultMessage: 'Payment terms and conditions',
  },
  nda: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.acceptConditions.nda',
    defaultMessage: 'General Non-disclosure agreement',
  },
  approveModalTitle: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.approve.modalTitle',
    defaultMessage: 'Approve',
  },
  approveTextAreaLabel: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.approve.textAreaLabel',
    defaultMessage: 'You can send a message to the coordinator here:',
  },
  approveSuccessToastr: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.approve.approveSuccessToastr',
    defaultMessage: 'Job approved',
  },
  approveButtonText: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.approve.buttonText',
    defaultMessage: 'Approve job',
  },
  denyModalTitle: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.deny.modalTitle',
    defaultMessage: 'Deny',
  },
  denyTextAreaLabel: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.deny.textAreaLabel',
    defaultMessage: 'Below you can send a message to the coordinator where you explain your denial of the task.',
  },
  denySuccessToastr: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.deny.denySuccessToastr',
    defaultMessage: 'Job denied',
  },
  denyButtonText: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.deny.buttonText',
    defaultMessage: 'Deny job',
  },
  noteModalTitle: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.note.modalTitle',
    defaultMessage: 'Send Message regarding',
  },
  noteTextAreaLabel: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.note.textAreaLabel',
    defaultMessage: 'Message:',
  },
  noteSuccessToastr: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.note.noteSuccessToastr',
    defaultMessage: 'Message sent',
  },
  noteButtonText: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.note.buttonText',
    defaultMessage: 'Send message',
  },
  unknown: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.acceptConditions.unknown',
    defaultMessage: 'Unknown',
  },
  buyoutSaveSuccess: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.approve.buyoutSaveSuccess',
    defaultMessage: 'Usages saved successfully',
  },
  buyoutsMessage: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.approve.buyoutsMessage',
    defaultMessage: 'Kindly provide us with your BEST rates for the potential usages if they are not already set, as we will quote based on these initial inputs. However, please note that the job is not guaranteed.',
  },
  total: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.approve.total',
    defaultMessage: 'Total',
  },
  buyoutTableQuantity: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.approve.buyoutTableQuantity',
    defaultMessage: 'Quantity',
  },
  buyoutTableMedia: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.approve.buyoutTableMedia',
    defaultMessage: 'Criteria',
  },
  buyoutTableUsage: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.approve.buyoutTableUsage',
    defaultMessage: 'Airing time',
  },
  buyoutTablePrice: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.approve.buyoutTablePrice',
    defaultMessage: 'Price',
  },
  usageTerms: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.approve.usageTerms',
    defaultMessage: 'Advertising workflow at VoiceArchive',
  },
  usageTermsValue: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.approve.usageTermsValue',
    defaultMessage: 'Click <a>here</a> to review',
  },
  usageCustomerCancelation: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.approve.usageCustomerCancelation',
    defaultMessage: 'Cancellation policy',
  },
  usageCustomerCancelationValue: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.approve.usageCustomerCancelationValue',
    defaultMessage: 'In the unlikely event that a client cancels the agreed usage within 14 days, a basic effort fee (BSF) will still be compensated',
  },
  territoryMarket: {
    id: 'containers.SupplierTaskPage.components.TaskActionDialog.approve.territoryMarket',
    defaultMessage: 'Territory',
  }
})
